<template>
	<Tabs
		v-model="tab"
		flat
		:items="tabs"
		class="mobile:pl-[15px]"
	/>
	<OrderCardV2
		v-if="tab === 'products'"
		:cart-products="cartProducts"
		:num-of-products="numOfProducts"
	/>
	<OrderCardV2
		v-if="tab === 'samples'"
		:cart-samples="cartSamples"
		:num-of-samples="numOfSamples"
	/>
</template>
<script setup lang="ts">
import OrderCardV2 from "@/components/MyCart/OrderCardV2.vue";

interface OrderProps {
	isCheckout?: boolean;
	cartProducts?: any;
	cartSamples?: Array<{ [key: string]: any }>;
	numOfProducts?: number;
	numOfSamples?: number;
}

defineProps<OrderProps>();

const tab = ref<string | null>(null);

const tabs = computed(
	(): Array<{ label: string | number; value: any }> => [
		{
			label: "Products",
			value: "products",
		},
		{
			label: "Samples",
			value: "samples",
		},
	]
);
</script>
